import React, { useState } from 'react';

function FindReplace() {
    const [inputText1, setInputText1] = useState('');
    const [lnagText1, setLnagText1] = useState('');

    const [inputText2, setInputText2] = useState('');
    const [lnagText2, setLnagText2] = useState('');

    const handleInputChange = async (value, setInputText, setLangText) => {
        // Update the text as is for continuous typing
        setInputText(value);
        setLangText(value);
    };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
                <input
                    type="text"
                    value={inputText1}
                    onChange={(e) => handleInputChange(e.target.value, setInputText1, setLnagText1)}
                    placeholder="Type in English (Input 1)"
                    style={{ width: '300px', padding: '10px', fontSize: '16px' }}
                />
                <p>Hindi Output 1: {lnagText1}</p>
            </div>

            <div>
                <input
                    type="text"
                    value={inputText2}
                    onChange={(e) => handleInputChange(e.target.value, setInputText2, setLnagText2)}
                    placeholder="Type in English (Input 2)"
                    style={{ width: '300px', padding: '10px', fontSize: '16px' }}
                />
                <p>Hindi Output 2: {lnagText2}</p>
            </div>
        </div>
    );
}

export default FindReplace;
